<div style="display: block;">
    <canvas baseChart
       [data]="data"
       [options]="options"
       [ngStyle]="{'height': chartHeight}"
       class="line-chart"
       id="line-chart"
       [type]="'line'"
       [attr.aria-label]="ariaLabel"
       >
    </canvas>
  </div>
  <div *ngIf="splitDateInRange" class="share-split-legend">
    <span class="share-split-dot"></span>
    <span>Indicates a share split occurred on this date.</span>
  </div>
